import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { Provider } from '@radix-ui/react-toast';

const ToastProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return jsx(Provider, Object.assign({}, props, { children: children }));
};
ToastProvider.displayName = "ToastProvider";

export { ToastProvider };
